// deps
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { StyleSheet } from "react-native";

// components
import { Row, Col } from "@cloudspire/legacy-resources/src/components/Grid";
import Button from "@cloudspire/legacy-resources/src/components/Button2";
import Text from "@cloudspire/legacy-resources/src/components/Text";
import { IconTrashO } from "@cloudspire/legacy-svg-icon-library";

const styles = StyleSheet.create({
  col: {
    justifyContent: "center",
  },
});

function BookingDiscountCode(props) {
  const { discountCode, estimateDiscount, invalid, onDelete } = props;

  const [savedName, setSavedName] = useState(estimateDiscount?.name);

  const intl = useIntl();

  useEffect(
    function () {
      if (estimateDiscount?.name !== savedName && estimateDiscount?.name) {
        setSavedName(estimateDiscount.name);
      }
    },
    [estimateDiscount, savedName]
  );

  const name = savedName ?? estimateDiscount?.name;

  return (
    <Row breakpointList={{ all: 3 }} col={{ all: 3 }}>
      <Col style={styles.col}>
        <Text>{discountCode}</Text>
      </Col>
      <Col style={[styles.col, { alignItems: "center" }]}>
        {name && <Text>{name}</Text>}

        {invalid && (
          <Text style={{ color: "red" }}>
            {intl.formatMessage({
              defaultMessage: " Code invalide",
            })}
          </Text>
        )}
      </Col>
      <Col style={[styles.col, { alignItems: "flex-end" }]}>
        <span>
          <Button
            label={intl.formatMessage({
              defaultMessage: " Supprimer",
            })}
            appearance="reset"
            onPress={onDelete}
          >
            <IconTrashO />
          </Button>
        </span>
      </Col>
    </Row>
  );
}

BookingDiscountCode.propTypes = {
  discountCode: PropTypes.string,
  estimateDiscount: PropTypes.object,
  invalid: PropTypes.bool,
  loading: PropTypes.bool,
  onDelete: PropTypes.func,
};

export default BookingDiscountCode;
